module.exports = __webpack_public_path__ + "img/Enrolment-(Icon).bcfdc19f.png";